/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function BlockquoteIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "blockquote", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M6 7.5H19", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M10 12.5H17", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M10 17.5H19", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M6.5 12V18", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(BlockquoteIcon);
export default ForwardRef;
//# sourceMappingURL=blockquoteIcon.js.map